import React from 'react';

export const BaselineSwapVert = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1492 14.5706V8.17525H12.3246V14.5706H9.58765L13.2369 18.2107L16.8862 14.5706H14.1492ZM7.76302 1.78906L4.11377 5.42919H6.85071V11.8245H8.67533V5.42919H11.4123L7.76302 1.78906Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
